import type { GetSubscriptions200SubscriptionsItemStatus } from './getSubscriptions200SubscriptionsItemStatus';

/**
 * 구독 정보 응답
 */
export type GetSubscriptions200SubscriptionsItem = {
  /** 결제 금액 */
  amount?: number;
  /**
   * 카드명 (마스킹된 정보)
   * @nullable
   */
  cardName?: string | null;
  /** 생성일시 */
  createdAt?: string;
  /**
   * 구독 종료일
   * @nullable
   */
  endDate?: string | null;
  /** 구독 ID */
  id?: number;
  /**
   * 마지막 결제일
   * @nullable
   */
  lastPaymentDate?: string | null;
  /**
   * 마지막 결제 결과
   * @nullable
   */
  lastPaymentResult?: string | null;
  /**
   * 다음 결제일
   * @nullable
   */
  nextBillingDate?: string | null;
  /** 주문 ID */
  orderId?: string;
  /** 상품명 */
  productName?: string;
  /**
   * 구독 시작일
   * @nullable
   */
  startDate?: string | null;
  /** 구독 상태 */
  status?: GetSubscriptions200SubscriptionsItemStatus;
  /** 수정일시 */
  updatedAt?: string;
  /** 사용자 ID */
  userId?: string;
};
